export default "__VITE_ASSET__B9c8zvDG__"